export const config = {
  bucketName: process.env.REACT_APP_BUCKETNAME,
  region:"ap-south-1", 
  accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY,
};
